<template>
    <router-view :key="$route.params.personUid"/>
</template>

<script>
export default {
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push('/');
    }
  },
};
</script>
